import React, { useEffect, useState } from 'react'
import api from '../../utils/axiosConfig';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

const NonAcademicFee = () => {
    const [feeParticulars, setFeeParticulars] = useState([]);
    const [selectedFee, setSelectedFee] = useState("");
    const [feeList, setFeeList] = useState([]);

    const navigate = useNavigate();

    const studentId = sessionStorage.getItem('student_uid');

    // ================= FETCH FEES =================
    const fetchFeeParticulars = async () => {
        try {
            const response = await api.get(`/fetch-fee-particulars`);
            setFeeParticulars(response.data);
        } catch (error) {
            console.error("Error fetching fee particulars:", error);
        }
    };

    useEffect(() => {
        fetchFeeParticulars();
    }, []);

    // ================= ADD FEE =================
    const handleAddFee = () => {
        if (!selectedFee) return;

        const selectedData = feeParticulars.find(
            f => Number(f.id) === Number(selectedFee)
        );

        if (!selectedData) return;

        const exists = feeList.some(
            item => Number(item.particular_id) === Number(selectedFee)
        );

        if (exists) {
            Swal.fire({
                title: 'Duplicate Fee',
                text: 'This fee already added',
                icon: 'warning',
            });
            return;
        }

        const newItem = {
            particular_id: selectedData.id,
            particular_name: selectedData.fee_particular_name,
            particular_amt: Number(selectedData.fee_amount ?? 0)
        };

        setFeeList([...feeList, newItem]);
        setSelectedFee("");
    };

    // ================= REMOVE =================
    const handleRemove = (index) => {
        setFeeList(feeList.filter((_, i) => i !== index));
    };

    // ================= GENERATE =================
    const handleGenerate = async () => {
        const total = feeList.reduce(
            (sum, item) => sum + Number(item.particular_amt || 0),
            0
        );

        const payload = {
            student_id: studentId,
            total_amt: total,
            non_academic_particulars: feeList
        };

        try {
            const response = await api.post('/store-non-academic-fee', payload);

            Swal.fire({
                title: response.data.title,
                text: response.data.message,
                icon: response.data.icon
            });
            setFeeList([]);
            navigate('/finance/payment/non-academic-tnx-list');
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed',
                icon: 'error',
            });
        }
    };

    return (
        <div className="container-fluid py-2">

            <div className="card shadow-sm">

                {/* HEADER */}
                <div className="card-header bg-primary text-white">
                    <h6 className="mb-0">
                        Non-Academic Money Receipt Generate
                    </h6>
                </div>

                <div className="card-body">

                    {/* ================= SELECT SECTION ================= */}
                    <div className="row g-2 align-items-end">

                        <div className="col-12 col-md-8">
                            <label className="form-label">Select Fee</label>

                            <select
                                className="form-select form-select-sm"
                                value={selectedFee}
                                onChange={(e) => setSelectedFee(e.target.value)}
                            >
                                <option value="">-- Select Fee --</option>
                                {feeParticulars.map(fee => (
                                    <option key={fee.id} value={fee.id}>
                                        {fee.fee_particular_name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-4">
                            <button
                                onClick={handleAddFee}
                                className="btn btn-primary w-100 mt-2 mt-md-0 btn-sm"
                            >
                                Add Fee
                            </button>
                        </div>

                    </div>

                    {/* ================= TABLE ================= */}
                    <div className="table-responsive mt-3">
                        <table className="table table-sm table-bordered align-middle">

                            <thead className="table-light">
                                <tr>
                                    <th>SL</th>
                                    <th>Particular</th>
                                    <th>Amount</th>
                                    <th style={{ width: "100px" }}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {feeList.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            No fee added
                                        </td>
                                    </tr>
                                ) : (
                                    feeList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.particular_name}</td>
                                            <td>{Number(item.particular_amt || 0).toFixed(2)}</td>
                                            <td>
                                                <button
                                                    onClick={() => handleRemove(index)}
                                                    className="btn btn-danger btn-sm w-100"
                                                >
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                            <tfoot>
                                <tr className="table-secondary">
                                    <th colSpan="2">Total</th>
                                    <th>
                                        {feeList
                                            .reduce((sum, item) => sum + Number(item.particular_amt || 0), 0)
                                            .toFixed(2)}
                                    </th>
                                    <th></th>
                                </tr>
                            </tfoot>

                        </table>
                    </div>

                    {/* ================= GENERATE BUTTON ================= */}
                    <button
                        onClick={handleGenerate}
                        className="btn btn-success w-100 mt-2"
                        disabled={feeList.length === 0}
                    >
                        Generate Receipt
                    </button>

                </div>

            </div>
        </div>
    )
}

export default NonAcademicFee;